import { scheduleTokenCheck } from './scheduleTokenCheck';

// For setAuthToken and setRefreshToken
// if setting local storage we clear any existing session storage values and vice versa
// we are doing this because of our access pattern, we always check both,
// to avoid having old values in any storage
export const setAuthToken = (rememberMe, token) => {
  if (rememberMe) {
    localStorage.setItem('token', token);
    sessionStorage.removeItem('token');
  } else {
    sessionStorage.setItem('token', token);
    localStorage.removeItem('token');
  }
};

export const setRefreshToken = (rememberMe, refreshToken) => {
  if (rememberMe) {
    localStorage.setItem('refreshToken', refreshToken);
    sessionStorage.removeItem('refreshToken');
  } else {
    sessionStorage.setItem('refreshToken', refreshToken);
    localStorage.removeItem('refreshToken');
  }
};

const setTokens = (rememberMe, token, refreshToken) => {
  setAuthToken(rememberMe, token);
  if (refreshToken) {
    setRefreshToken(rememberMe, refreshToken);
  }
};

export const initAuthToken = (response, rememberMe, refreshToken = '') => {
  if (response.ok) {
    const token = response.headers.get('Authorization');
    setTokens(rememberMe, token, refreshToken);

    // Call scheduleTokenCheck to set timer to refresh the auth token
    // when the threshold is met & the token expiry time is close
    scheduleTokenCheck();
    return;
  } else {
    throw new Error(`Requesting auth token failed.`);
  }
};
